import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { text, curve, translate } from './anim';
import { UserMode } from '@/components/context/ModeContext';
import { useMediaQuery } from '@/components/utils/useMediaQuery';
import clsx from 'clsx';
import './style.scss';

const anim = (variants) => {
  return {
    variants,
    initial: 'initial',
    animate: 'enter',
    exit: 'exit',
  };
};

export default function Curve({ children, backgroundColor }) {
  const router = useLocation();
  // const { darkMode, setDarkMode } = UserMode();

  const [isChangingRoute, setIsChangingRoute] = useState(false);

  const minMd = useMediaQuery('(min-width: 850px)');

  const [dimensions, setDimensions] = useState({
    width: null,
    height: null,
  });

  useEffect(() => {
    function resize() {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    resize();
    window.addEventListener('resize', resize);

    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);

  useEffect(() => {
    setIsChangingRoute(true);
    // console.log('changing route ::: ', isChangingRoute);
    const timeout = setTimeout(() => {
      setIsChangingRoute(false);
      // console.log('changing route timeout ::: ', isChangingRoute);
    }, 3000); // Durée de l'animation

    return () => clearTimeout(timeout);
  }, [router.pathname]);

  return (
    <>
      {minMd ? (
        <div className="page curve" style={{ backgroundColor }}>
          <AnimatePresence mode="wait">
            <motion.div key={router.key}>
              <motion.p
                className={clsx(
                  'route max-md:text-2xl text-[5rem] font-bebas tracking-[0.1rem]',
                  isChangingRoute && 'z-[9999999]'
                )}
                {...anim(text)}
              >
                Yaghmurassen <span className="mt-6 block md:mt-0">Sainson</span>
              </motion.p>
              {dimensions.width != null && <SVG {...dimensions} />}
              {children}
            </motion.div>
          </AnimatePresence>
        </div>
      ) : (
        <div className="page" style={{ backgroundColor }} key={router.key}>
          {children}
        </div>
      )}
    </>
  );
}

const SVG = ({ height, width }) => {
  const initialPath = `
        M0 300 
        Q${width / 2} 0 ${width} 300
        L${width} ${height + 300}
        Q${width / 2} ${height + 600} 0 ${height + 300}
        L0 0
    `;

  const targetPath = `
        M0 300
        Q${width / 2} 0 ${width} 300
        L${width} ${height}
        Q${width / 2} ${height} 0 ${height}
        L0 0
    `;

  return (
    <motion.svg className="curve-svg" {...anim(translate)}>
      <motion.path {...anim(curve(initialPath, targetPath))} />
    </motion.svg>
  );
};
